export const truncateTextInMiddle = (
  originalText: string,
  maxLength: number,
  separator?: string
) => {
  if (originalText.length <= maxLength) return originalText;

  const separatorToUse = separator || '...';
  const sepLen = separatorToUse.length;
  const charsToShow = maxLength - sepLen;
  const frontChars = Math.ceil(charsToShow / 2);
  const backChars = Math.floor(charsToShow / 2);

  return (
    originalText.slice(0, frontChars) +
    separatorToUse +
    originalText.slice(originalText.length - backChars)
  );
};
